// User.js — Handles all user-related API logic
import { getApiUrl } from './ApiMaster';

// General Meta Profile APIs
export async function registerOrUpdateUserProfile(profile) {
  const response = await fetch(`${getApiUrl()}/edu/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profile)
  });
  if (!response.ok) throw new Error(`Failed to store user profile: ${response.statusText}`);
  return await response.json();
}

export async function getUserProfile(email) {
  const response = await fetch(`${getApiUrl()}/edu/users/data/${encodeURIComponent(email)}`);
  if (!response.ok) throw new Error(`Failed to retrieve user profile: ${response.statusText}`);
  return await response.json();
}

// Legacy User Functions (if still needed)
export async function signupUser(userId, name, email) {
  const response = await fetch(`${getApiUrl()}/edu/users/signup/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_id: userId, name, email }),
  });
  if (!response.ok) throw new Error(`Signup failed: ${response.statusText}`);
  return await response.json();
}

export async function loginUser(userId) {
  const response = await fetch(`${getApiUrl()}/edu/users/login/${userId}`);
  if (!response.ok) throw new Error(`Login failed: ${response.statusText}`);
  return await response.json();
}

export async function addFleetData(userId, fleet) {
  const response = await fetch(`${getApiUrl()}/edu/users/fleet/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_id: userId, fleet }),
  });
  if (!response.ok) throw new Error(`Adding fleet data failed: ${response.statusText}`);
  return await response.json();
}

export async function deleteFleetData(userId, tileId) {
  const response = await fetch(`${getApiUrl()}/edu/users/fleet/${userId}/${tileId}`, {
    method: "DELETE",
  });
  if (!response.ok) throw new Error(`Deleting fleet data failed: ${response.statusText}`);
  return await response.json();
}

export async function getFleetData(userId) {
  const response = await fetch(`${getApiUrl()}/edu/users/fleet/${userId}`);
  if (!response.ok) throw new Error(`Fetching fleet data failed: ${response.statusText}`);
  return await response.json();
}

// MBTI & Profile Enrichment
export async function updateUserData(email, data) {
  const response = await fetch(`${getApiUrl()}/edu/users/data/${encodeURIComponent(email)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(`Updating user data failed: ${response.statusText}`);
  return await response.json();
}

export async function fetchUserMBTI(email) {
  const response = await fetch(`${getApiUrl()}/edu/users/data/${encodeURIComponent(email)}`);
  if (!response.ok) throw new Error(`Fetching MBTI data failed: ${response.statusText}`);
  return await response.json();
}
